import React from "react";
import { useTranslation } from "react-i18next";
import type { RiskBadgeProps } from "../types/component.types";

export const RiskBadge: React.FC<RiskBadgeProps> = ({
  risk,
  size = "md",
  className = "",
}) => {
  const { t } = useTranslation();

  const sizeClasses = {
    sm: "px-2 py-0.5 text-xs",
    md: "px-3 py-1 text-sm",
    lg: "px-4 py-1.5 text-base",
  };

  const riskClasses = {
    low: "bg-atlantis-100 text-atlantis-800 border-atlantis-200",
    medium: "bg-yellow-100 text-yellow-800 border-yellow-200",
    high: "bg-orange-100 text-orange-800 border-orange-200",
    critical: "bg-red-100 text-red-800 border-red-200",
  };

  return (
    <span
      className={`
        inline-flex items-center font-medium rounded-full border
        ${sizeClasses[size]}
        ${riskClasses[risk]}
        ${className}
      `}
    >
      {t(`documentReview.riskLevels.${risk}`)}
    </span>
  );
};

